import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';



export const details = (id,params) => {
    params = parseParam(params);
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/check/findCheckDetailByShopId/${id}?`+params,
        method: 'GET',
    })
};

export const calculatedBalance = (shopId) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/accountBalance/calculatedBalance/${shopId}`,
        method: 'GET',
    })
};
export const send = (id) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/check/send/${id}`,
        method: 'GET',
    })
};
export const updateDraftCheck = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/check/updateDraftCheck`,
        method: 'PUT',
        data: data
    })
};
export const keepCheck = (data) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/check/keepCheck`,
        method: 'POST',
        data: data
    })
};
